import { useLocation } from 'react-router-dom';
import type { BackofficeUserType } from '@/backoffice/config/theme';

/** Détermine admin vs super-admin pour les pages partagées entre les deux espaces. */
export function useAdminContext(): BackofficeUserType {
  const { pathname } = useLocation();
  return pathname.includes('/super-admin') ? 'super_admin' : 'admin';
}
